var $ = require('../../../jCube');

exports.controlButton = {

    build: function(_data) {
        return $.assign({}, _data, {
            tagName: 'button',
            container: {
                className: 'fb-button'
            },
            label: '',
            innerHTML: _data.label || _data.value
        });
    }
};